module.exports = __webpack_public_path__ + "img/tech-back2.jpg";